import AdminAvailableWorkers from './AdminAvailableWorkers';

export default AdminAvailableWorkers;
